import type { FunctionComponent } from 'react'

export const AspectRatioContainer: FunctionComponent<
  React.PropsWithChildren<{
    width: number
    height: number
    percentOfViewPort: number
  }>
> = ({ width, height, percentOfViewPort, children }) => {
  const percent = percentOfViewPort / 100
  const baseStyles: React.CSSProperties = {
    position: 'relative',
    height: `calc(${percent}vw * (${percentOfViewPort} * (${height} / ${width})))`,
    width: `calc(${percent}vw * ${percentOfViewPort})`,
    margin: 'auto',
  }

  // Unique class to scope the dynamic media query
  const className = `ar-${width}-${height}-${percentOfViewPort}`

  return (
    <div className={className} style={baseStyles}>
      <style>{`
        @media (min-aspect-ratio: ${width}/${height}) {
          .${className} {
            height: calc(${percent}vh * ${percentOfViewPort});
            width: calc(${percent}vh * (${percentOfViewPort} * (${width} / ${height})));
          }
        }
      `}</style>
      {children}
    </div>
  )
}
